import {
  Monitor, Building2, Store, RefreshCcw, ShieldCheck, LayoutGrid, ShoppingBag, Workflow, Instagram, Search,
  Receipt, Gem, LifeBuoy, Sparkles, MapPin, UserCheck,
} from "lucide-react";

const MAP = { Monitor, Building2, Store, RefreshCcw, ShieldCheck, LayoutGrid, ShoppingBag, Workflow, Instagram, Search, Receipt, Gem, LifeBuoy, Sparkles, MapPin, UserCheck };

export const Icon = ({ name, ...props }) => {
  const C = MAP[name] || Sparkles;
  return <C {...props} />;
};
